export enum AuthorizeActionType {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  SIGNUP = "SIGNUP",
  UPDATE_PASSWORD = "UPDATE_PASSWORD",
  UPDATE_USER = "UPDATE_USER"
}
